@let title = text();
@if (title) {
  <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
}

@if (controlHasError()) {
  <div class="alert  alert-danger error pill form-error-list">
    <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
      <ul>
        @for (err of baseForm.errorMap.get(question.id!); track err) {
          <li>
            <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
}
@if (control) {
  <ng-container>
    @if (control.value) {
      <input #input [attr.type]="inputType"
             [attr.name]="question.id"
             [attr.id]="question.id"
             class="form-control {{inputClass}}"
             [attr.autocomplete]="determineAutocompleteValue(question.id!)"
             [required]="question.required || false" [attr.aria-required]="question.required"
             [attr.aria-invalid]="controlHasError()"
             [formControl]="control | asFormControl"
             (keydown.enter)="onEnter($event)"
             (blur)="revalidateInput()"
             (input)="onValueChange($event);revalidateInput()"
             [attr.aria-labelledby]="getAriaLabels('label')"
             [attr.aria-label]="getLabel()"
             [ngClass]="{ 'is-invalid': controlHasError() }"/>
    }
    @if (control.validator && (!control.untouched || baseForm.isSubmitted())) {
      <div #feedback
           class="feedback-icon" aria-hidden="true">
        <i class="fa" aria-hidden="true"
           [ngClass]="controlErrorClass()"></i>
      </div>
    }
    <ng-content></ng-content>
  </ng-container>
}
